import { render, staticRenderFns } from "./travel-insurance-policy.vue?vue&type=template&id=5f1f2499&scoped=true"
import script from "./travel-insurance-policy.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-policy.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-policy.vue?vue&type=style&index=0&id=5f1f2499&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f2499",
  null
  
)

export default component.exports